module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v(_vm._s(_vm.flashMessage))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.reportType),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Report Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportgeneration.reportType),
      expression: "reportgeneration.reportType"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "reportType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.reportgeneration, "reportType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getSelectiveStation]
    }
  }, [_c('option', {
    attrs: {
      "value": "logbook"
    }
  }, [_vm._v("Vehicle Log Book")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hcv_ms"
    }
  }, [_vm._v("Data HCV Mother Station")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hcv_dbs"
    }
  }, [_vm._v("Data HCV DB Station")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "dsr"
    }
  }, [_vm._v("Daily Sales Report")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "reportType",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Report Type is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.downloadType),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Download Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportgeneration.downloadType),
      expression: "reportgeneration.downloadType"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "downloadType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.reportgeneration, "downloadType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "PDF"
    }
  }, [_vm._v("PDF")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "XLSX"
    }
  }, [_vm._v("Excel")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "downloadType",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Download Type is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', {
    staticClass: "col-md-12"
  }, [_vm._v("Report Criterion")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Record Start Date")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.startDate),
    attrs: {
      "auto-label": ""
    }
  }, [(this.reportgeneration.reportType != 'dsr') ? _c('date-picker', {
    attrs: {
      "id": "startDate",
      "lang": "en",
      "name": "startDate",
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.reportgeneration.startDate),
      callback: function($$v) {
        _vm.$set(_vm.reportgeneration, "startDate", $$v)
      },
      expression: "reportgeneration.startDate"
    }
  }) : _vm._e(), _vm._v(" "), (this.reportgeneration.reportType == 'dsr') ? _c('VueCtkDateTimePicker', {
    attrs: {
      "id": "startDate",
      "lang": "en",
      "name": "startDate",
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "format": "MM-DD-YYYY hh:mm a"
    },
    model: {
      value: (_vm.reportgeneration.startDate),
      callback: function($$v) {
        _vm.$set(_vm.reportgeneration, "startDate", $$v)
      },
      expression: "reportgeneration.startDate"
    }
  }) : _vm._e(), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "startDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Record Start Date is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Record End Date")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.endDate),
    attrs: {
      "auto-label": ""
    }
  }, [(this.reportgeneration.reportType != 'dsr') ? _c('date-picker', {
    attrs: {
      "id": "endDate",
      "lang": "en",
      "name": "endDate",
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.reportgeneration.endDate),
      callback: function($$v) {
        _vm.$set(_vm.reportgeneration, "endDate", $$v)
      },
      expression: "reportgeneration.endDate"
    }
  }) : _vm._e(), _vm._v(" "), (this.reportgeneration.reportType == 'dsr') ? _c('VueCtkDateTimePicker', {
    attrs: {
      "id": "endDate",
      "lang": "en",
      "name": "endDate",
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "format": "MM-DD-YYYY hh:mm a"
    },
    model: {
      value: (_vm.reportgeneration.endDate),
      callback: function($$v) {
        _vm.$set(_vm.reportgeneration, "endDate", $$v)
      },
      expression: "reportgeneration.endDate"
    }
  }) : _vm._e(), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "endDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Record End Date is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.region),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Geographical Area")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportgeneration.region),
      expression: "reportgeneration.region"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "region"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.reportgeneration, "region", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getStationList]
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select G.A")]), _vm._v(" "), _vm._l((_vm.region_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                                " + _vm._s(item.value) + "\n                                            ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "region",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("G.A is a required field")])])], 1)], 1), _vm._v(" "), (this.reportgeneration.reportType != 'logbook') ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.station),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Location")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportgeneration.station),
      expression: "reportgeneration.station"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "station"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.reportgeneration, "station", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Select Location")]), _vm._v(" "), _vm._l((_vm.station_list), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                                " + _vm._s(item.value) + "\n                                            ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "station",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Location is a required field")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(this.reportgeneration.reportType == 'logbook') ? _c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.vehicleId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Vehicle")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reportgeneration.vehicleId),
      expression: "reportgeneration.vehicleId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "vehicleId",
      "disabled": this.disabledInput
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.reportgeneration, "vehicleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Vehicle")]), _vm._v(" "), _vm._l((_vm.vehicle_no), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                                            " + _vm._s(item.value) + "\n                                        ")])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All vehicles")])], 2)]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Report'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gredientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.createReport
    }
  }, [_vm._v("Generate Report")])], 1)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a2597ec2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/reports/ReportCreate.vue
// module id = 2381
// module chunks = 1